const theme = {
  fontName: 'Inter',

  button: {
    loadingType: 'TailSpin',
    primary: {
      height: '5rem',
      background: 'rgba(247, 59, 32, 1)',
      border: 'none',
      borderRadius: '12px',
      boxShadow: '0 0 25px rgba(46, 53, 56, 0.1)',
      color: '#ffffff',
      fontSize: '1.6rem',
      fontWeight: '600',
      iconColor: '#ffffff',
      iconSpacing: '1.4rem',
      padding: '0 1rem',

      hoverBackground: 'rgba(247, 59, 32, 0.75)',
      hoverBorder: 'none',
      hoverBoxShadow: '0 0 25px rgba(46, 53, 56, 0.1)',
      hoverColor: '#ffffff',

      disabledColor: 'rgba(247, 59, 32, 0.3)',
      disabledBackground: '#FEE9E6',
      disabledBorder: 'none',
      disabledBoxShadow: '0 1px 10px rgba(0, 0, 0, 0.08)'
    },
    secondary: {
      height: '5rem',
      background: '#FFF6F5',
      border: 'none',
      borderRadius: '12px',
      boxShadow: 'none',
      color: '#000000',
      fontSize: '1.6rem',
      fontWeight: '600',
      iconColor: '#000000',
      iconSpacing: '1.4rem',
      padding: '0 1rem',

      hoverBackground: '#FFF6F5',
      hoverBorder: 'none',
      hoverBoxShadow: '0 0 5px rgba(46, 53, 56, 0.1)',
      hoverColor: '#000000',

      disabledColor: 'rgba(247, 59, 32, 0.3)',
      disabledBackground: '#FFF6F5',
      disabledBorder: 'none',
      disabledBoxShadow: '0 1px 10px rgba(0, 0, 0, 0.08)'
    },
    alternative: {
      height: '5rem',
      background: '#ff3131',
      border: 'none',
      borderRadius: '12px',
      boxShadow: 'none',
      color: '#ffffff',
      fontSize: '1.6rem',
      fontWeight: '600',
      iconColor: '#ffffff',
      iconSpacing: '1.4rem',
      padding: '0 1rem',

      hoverBackground: '#ff5252',
      hoverBorder: 'none',
      hoverBoxShadow: 'none',
      hoverColor: '#ffffff',

      disabledColor: 'rgba(247, 59, 32, 0.3)',
      disabledBackground: '#FEE9E6',
      disabledBorder: 'none',
      disabledBoxShadow: '0 1px 10px rgba(0, 0, 0, 0.08)'
    },
    'round-primary': {
      height: '4.6rem',
      background: '#ffffff',
      border: 'none',
      borderRadius: '12px',
      boxShadow: '0 1px 10px rgba(0, 0, 0, 0.08)',
      color: '#000000',
      fontSize: '1.4rem',
      fontWeight: '600',
      iconColor: '#ff3131',
      iconHeight: '1.4rem',
      iconSpacing: '6px',
      padding: '0 2.5rem',

      hoverBackground: '#ffffff',
      hoverBorder: 'none',
      hoverBoxShadow: '0 2px 15px rgba(0, 0, 0, 0.15)',
      hoverColor: '#000000',

      disabledColor: 'rgba(247, 59, 32, 0.3)',
      disabledBackground: '#FEE9E6',
      disabledBorder: 'none',
      disabledBoxShadow: 'none'
    },
    'round-secondary': {
      height: '4.6rem',
      background: '#1a1a1a',
      border: 'none',
      borderRadius: '12px',
      boxShadow: 'none',
      color: '#828282',
      fontSize: '1.4rem',
      fontWeight: '600',
      iconColor: '#4f4f4f',
      iconHeight: '1.4rem',
      iconSpacing: '6px',
      padding: '0 2.5rem',

      hoverBackground: '#1a1a1a',
      hoverBorder: 'none',
      hoverBoxShadow: 'none',
      hoverColor: '#ffffff',

      disabledColor: 'rgba(247, 59, 32, 0.3)',
      disabledBackground: '#FEE9E6',
      disabledBorder: 'none',
      disabledBoxShadow: 'none'
    },
    delete: {
      height: '4.6rem',
      background: 'rgba(255, 49, 49, 0.7)',
      border: 'none',
      borderRadius: '12px',
      boxShadow: 'none',
      color: '#ffffff',
      fontSize: '1.4rem',
      fontWeight: '600',
      iconColor: '#ffffff',
      iconHeight: '1.4rem',
      iconSpacing: '6px',
      padding: '0 2.5rem',

      hoverBackground: 'rgba(255, 49, 49, 0.7)',
      hoverBorder: 'none',
      hoverBoxShadow: '0 2px 15px rgba(0, 0, 0, 0.15)',
      hoverColor: '#ffffff',

      disabledColor: 'rgba(247, 59, 32, 0.3)',
      disabledBackground: '#FEE9E6',
      disabledBorder: 'none',
      disabledBoxShadow: 'none'
    }
  },

  checkbox: {
    checkedIconBackgroundColor: '#FFF6F5',
    checkedIconBorderColor: '#FEE9E6',
    iconBackground: '#ffffff',
    iconBorder: '1px solid #dadada',
    iconBorderRadius: '0.3rem',
    iconSize: '1.6rem',
    fontSize: '1.6rem',
    fontStyle: 'normal',
    fontWeight: '500',
    textColor: '#a3b8c2'
  },

  dataTable: {
    body: {
      backgroundColor: '#ffffff',
      border: '1px solid #e5e5e5',
      borderColor: '#e5e5e5',
      textColor: '#000000',
      fontSize: '1.6rem',
      fontWeight: '500',
      dropShadow: '0 1px 10px rgba(0, 0, 0, 0.08)',
      infoLineColor: '#939ea7'
    },
    head: {
      background: 'rgba(163, 184, 194, 0.3)',
      border: '2px solid #e5e5e5',
      textColor: '#a4a6b0',
      fontSize: '1.2rem',
      fontWeight: 'bold'
    },
    hover: {
      backgroundColor: 'rgba(163, 184, 194, 0.1);',
      border: '1px solid #f4f6f6',
      textColor: '#000000'
    }
  },

  dropTarget: {
    background: '#FEE9E6',
    border: '2px solid #828282',
    borderRadius: '3px',
    textColor: '#000000',
    fontSize: '1.6rem',
    fontWeight: 'normal'
  },

  gridTable: {
    border: '1px solid #e5e5e5',
    fontSize: '1.4rem',
    fontSize2: '1.6rem',
    fontWeight: '500',
    lineHeight: '1.7rem',
    lineHeight2: '2rem',
    labelColor: '#85a0ad',
    valueColor: '#000000',
    negativeColor: '#ee2b2b',
    positiveColor: '#59b300',
    rowPadding: '1rem 0',
    totalFontSize: '2rem',
    totalFontSize2: '2.4rem',
    totalFontWeight: 'bold',
    totalLineHeight: '2.4rem',
    totalLineHeight2: '3rem'
  },

  input: {
    label: {
      textColor: '#85a0ad',
      fontSize: '1rem',
      fontWeight: '400',
      lineHeight: 'normal',
      textTransform: 'uppercase',
      marginBottom: '0.5rem',
      marginLeft: '0',
      asteriskColor: '#ff3131',
      asteriskMargin: '3px',
      asteriskPosition: 'right',
      paddingWithIcon: '2.5rem',
      paddingRequired: '1.7rem'
    },
    error: {
      textColor: '#ff3131',
      padding: '0',
      marginTop: '1rem'
    },
    wrapper: {
      marginBottom: '2rem'
    },
    container: {
      textColor: '#000000',
      fontSize: '1.4rem',
      fontWeight: '400',
      lineHeight: '1.7rem',
      background: '#FEE9E6',
      borderWidth: '1px',
      borderRadius: '16px',
      padding: '0 2rem',
      iconColor: '#85a0ad',
      errorBorderColor: 'rgba(163, 184, 194, 0.3)',
      errorBorderWidth: '1px',
      focusedBorderColor: 'rgba(163, 184, 194, 0.3)',
      focusedBorderWidth: '1px'
    },
    placeholder: {
      textColor: '#85a0ad',
      fontSize: '1.4rem',
      fontWeight: '400',
      lineHeight: '1.7rem'
    },
    dropDown: {
      controlBorder: 'none',
      controlBorderRadius: '0',
      controlPadding: '0',
      indicatorColor: '#D72208',
      menuBackground: '#FFF6F5',
      menuBorder: 'none',
      menuBorderRadius: '0',
      menuMargin: '0',
      menuPadding: '0',
      openedBackground: 'transparent',
      openedBorder: 'none',
      openedBorderRadius: '12px',
      openedColor: '#000000',
      optionBorder: 'none',
      optionBorderRadius: '12px',
      optionColor: '#000000',
      optionFontSize: '1.6rem',
      optionFontWeight: 'normal',
      optionLineHeight: 'normal',
      optionMargin: '0',
      optionPadding: '1rem',
      optionBackground: '#FFF6F5',
      focusedOptionColor: '#000000',
      focusedOptionBackground: '#FEE9E6',
      buttonColor: '#000000',
      buttonTextAlign: 'left',
      buttonBorderRadius: '0',
      buttonBackground: '#FEE9E6',
      buttonMargin: '0',
      buttonWidth: 'auto'
    },
    settings: {
      height: '4.6rem',
      singleSelect: false,
      autofillBackground: '#FEE9E6',
      dropDownArrowColor: '#85A0AD',
      textareaMargin: '0',
      textareaPadding: '1rem 0',
      hideLabelWhenEmpty: false,
      showPasswordWithText: false
    }
  },

  progressBar: {
    background: '#d9d9d9',
    colorGreen: 'rgba(68, 204, 0, 0.5)',
    colorRed: 'rgba(255, 49, 49, 0.5)'
  },

  pagination: {
    marginPages: 2,
    minPagesVisible: 0,
    noArrowButtons: true,
    showPageLabel: true,
    fontSize: '1.2rem',
    fontWeight: '500',
    lineHeight: '1.5rem',
    textColor: '#85a0ad',
    backgroundColor: 'transparent',
    buttonBorderColor: 'rgba(163, 184, 194, 0.3)',
    buttonRadius: '4px',
    buttonMargin: '1rem',
    buttonSize: '3rem',
    buttonTextColor: '#85a0ad',
    buttonHoverBorderColor: 'rgba(163, 184, 194, 0.3)',
    buttonHoverTextColor: '#000000',
    buttonActiveBackground: '#000000',
    buttonActiveBorderRadius: '4px',
    buttonActiveBoxShadow: 'none',
    buttonActiveTextColor: '#ffffff'
  },

  radioButton: {
    iconSize: '2.4rem',
    iconSpacing: '1.6rem',
    fontSize: '1.6rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '2rem',
    textColor: '#828282',
    loadingColor: '#828282',
    loadingSize: '30'
  }
}

export default theme
